/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum EntityElementActionsEnum {
    DELETE = 'DELETE',
    EDIT = 'EDIT'
}
